import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { Action } from 'redux';
import { SET_ACTIVE_ARTIST } from '../../artist/actions';
import { ListReleasesSummary } from '../action-creators';
import { CREATE_RELEASE_SUCCESS, TAKEDOWN_RELEASE_SUCCESS } from '../actions';


export const listArtistReleasesEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action>(
      SET_ACTIVE_ARTIST,
      CREATE_RELEASE_SUCCESS,
      TAKEDOWN_RELEASE_SUCCESS
    ),
    mergeMap(() => [
      new ListReleasesSummary()
    ])
  );